module.exports = __webpack_public_path__ + "static/media/21-2.752bebb0.mp3";